import React from 'react';

function ChunkFormula() {
	return <div>formula</div>;
}

export default ChunkFormula;
